import React, { useMemo, useState } from 'react';
import MealItem from './MealItem';
import MealSorting from './Sorting/MealSorting';
import Meal from '../../models/meal';
import { Grid } from '@mui/material';

interface MealListProps {
  meals: Meal[];
}

const MealList = (props: MealListProps) => {
  const [sortingValue, setSortingValue] = useState('');

  const sortingChangeHandler = (sorting: any) => {
    setSortingValue(sorting);
  };

  const sortedMeals = useMemo(() => {
    if (sortingValue === 'popularity') {
      return [...props.meals].sort((a, b) => {
        if (a.tastiness !== null && b.tastiness !== null) return b.tastiness - a.tastiness;
        if (a.tastiness !== null) return -1;
        if (b.tastiness !== null) return 1;
        return 0;
      });
    }
    if (sortingValue === 'healthiness') {
      return [...props.meals].sort((a, b) => {
        if (a.healthiness !== null && b.healthiness !== null) return b.healthiness - a.healthiness;
        if (a.healthiness !== null) return -1;
        if (b.healthiness !== null) return 1;
        return 0;
      });
    }
    return props.meals;
  }, [props.meals, sortingValue]);

  return (
    <Grid container className="meal-list" spacing={{ xs: 2, md: 4 }}>
      <Grid item xs={12}>
        <MealSorting selected={sortingValue} onSortingChange={sortingChangeHandler} />
      </Grid>
      {sortedMeals.map((meal) => (
        <Grid key={meal.id} item xs={12} md={6}>
          <MealItem meal={meal} />
        </Grid>
      ))}
    </Grid>
  );
};

export default MealList;
